import { MileageRateConfigurationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { MileageInformation } from '../../../Blocks/mileage/MileageInformation'
import { CustomizationProps } from '../../../withCustomizationFields'
import { PermissionsProps } from '../../../withFieldPermissions'
import FormBlock from '../../FormBlock'

interface Props extends PermissionsProps, CustomizationProps {
  rates?: MileageRateConfigurationFragment[]
  isCalculatingDistance?: boolean
  setIsCalculatingDistance?: (loading: boolean) => void
}

const MileageInformationSection = (props: Props) => {
  const { rates, setIsCalculatingDistance } = props

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.mileage_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.mileage_information_subtitle')}
    >
      <MileageInformation
        {...props}
        rates={rates}
        setIsCalculatingDistance={setIsCalculatingDistance}
      />
    </FormBlock>
  )
}

export default MileageInformationSection
